import React, { useState } from "react";
import { Dialog } from "@mui/material";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";
import SecondaryButton from "../Components/SecondaryButton";
import { TfiReload } from "react-icons/tfi";

const SetPasswordModal = ({ open, setOpen, deleteFunction, deleting }) => {
  const [passwordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };
  const handleClose = () => {
    setOpen(!open);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="dialog-title"
      PaperProps={{ style: { borderRadius: 20, padding: 15 } }}
    >
      {deleting ? (
        <center>
          <div className="flex justify-center items-center w-[350px] py-7 px-5 text-center">
            <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-black"></div>
          </div>
        </center>
      ) : (
        <div className="flex flex-col justify-center content-center w-[450px] h-[240px]">
          <h1 className="flex justify-center font-bold text-2xl text-secondary">
            Set Password
          </h1>
          <div className="flex justify-center">
            <div className="flex flex-row justify-between primary-input mt-6 mx-4">
              <input
                type={passwordVisible ? "text" : "password"}
                placeholder="Enter Password"
                className=" w-full focus:outline-none bg-transparent"
              />
              <button
                onClick={togglePasswordVisibility}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                }}
                className="focus:outline-none"
              >
                {passwordVisible ? (
                  <IoEyeOutline className="font-bold text-gray-500" />
                ) : (
                  <IoEyeOffOutline className="font-bold text-gray-500" />
                )}
              </button>
            </div>
          </div>
          <div className="flex justify-center mt-8">
            <SecondaryButton text="Update" Icon={TfiReload} />
          </div>
        </div>
      )}
    </Dialog>
  );
};

export default SetPasswordModal;
